import { InputLabel, TextField } from "@mui/material"
import { Fragment } from "react"
import { uid } from "uid"

function InputFieldA({ id, label, type, name, value, placeholder, onChangeFun, rows, endIcon, startIcon, ref, ...rest }) {
  id = id || uid(6)
  const handleOnChnage = onChangeFun || null

  return (
    <Fragment>
      {label &&
        <InputLabel
          htmlFor={id}
        >{label}
        </InputLabel>
      }
      <TextField
        fullWidth
        hiddenLabel
        size="small"
        id={id || null}
        rows={rows || 4}
        variant="outlined"
        name={name || null}
        autoComplete="true"
        type={type || "text"}
        inputRef={ref || null}
        onChange={handleOnChnage}
        placeholder={placeholder}
        defaultValue={value || null}
        multiline={type === "textarea"}
        slotProps={{
          input: {
            endAdornment: endIcon || null,
            startAdornment: startIcon || null,
          }
        }}
        {...rest}
      />
    </Fragment>
  )
}

export default InputFieldA